module.exports = __webpack_public_path__ + "img/5.e3b651a9.png";